
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    page: { type: Object, required: true },
  },
})
